export const contactInfo = {
  title: '联系我们',
  subtitle: '投稿 · 合作 · 反馈',
  description: '欢迎通过以下方式与我们取得联系。无论是内容投稿、商务合作还是使用反馈，我们都会在第一时间回复。',
  email: 'contact@91yingshi.com',
  wechat: '91yingshi_official',
  qqGroup: '88372615',
};

export const updateItems = [
  {
    id: 1,
    date: '2026-07-30',
    title: '《消失的她2》高清修复版全网首发上线',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '暑期档热播剧《长安十二时辰2》全36集已更新完毕',
    tag: '剧集完结',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '韩国犯罪悬疑片《破墓》中文字幕版独家上线',
    tag: '独家引进',
  },
  {
    id: 4,
    date: '2026-07-22',
    title: '平台服务器全面升级，4K专区播放速度提升300%',
    tag: '系统公告',
  },
  {
    id: 5,
    date: '2026-07-18',
    title: '《周处除三害》未删减导演剪辑版加入片库',
    tag: '新片上线',
  },
  {
    id: 6,
    date: '2026-07-15',
    title: '2026下半年最受期待十大华语电影片单发布',
    tag: '专题策划',
  },
  {
    id: 7,
    date: '2026-07-10',
    title: '日剧《重启人生》全10集字幕精校版上线',
    tag: '剧集上线',
  },
  {
    id: 8,
    date: '2026-07-05',
    title: '观影反馈通道正式开通，意见被采纳送会员体验',
    tag: '用户福利',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20photography%20of%20young%20Chinese%20woman%20in%20warm%20cinema%20lighting%2C%20soft%20shadows%2C%20professional%20headshot%20style%2C%20warm%20amber%20tones&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '星辰大海',
    date: '2天前',
    content: '片源更新速度真的没话说，昨晚影院刚上的新片今天就能看到高清版了，画质清晰不卡顿！',
    rating: 5,
    tag: '老用户',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20photography%20of%20Chinese%20man%20in%20warm%20evening%20light%2C%20soft%20cinematic%20lighting%2C%20professional%20headshot%20style%2C%20warm%20golden%20tones&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '电影猎人',
    date: '5天前',
    content: '分类索引做得太棒了，找老片特别方便。韩影专区和日剧专区简直是宝藏，推荐给身边所有朋友了。',
    rating: 5,
    tag: '资深影迷',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20photography%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20amber%20tones&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '追剧达人',
    date: '1周前',
    content: '之前用别的平台经常缓冲卡顿，换到这里之后体验完全不一样了。即点即播是真的快，而且没有烦人的弹窗广告。',
    rating: 5,
    tag: '新用户',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '华语新片精选',
    count: 128,
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    id: 2,
    title: '韩影高分专区',
    count: 86,
    icon: 'ri-slideshow-line',
    color: 'accent',
  },
  {
    id: 3,
    title: '日剧经典合集',
    count: 94,
    icon: 'ri-tv-line',
    color: 'secondary',
  },
  {
    id: 4,
    title: '好莱坞大片',
    count: 203,
    icon: 'ri-earth-line',
    color: 'primary',
  },
  {
    id: 5,
    title: '悬疑推理剧场',
    count: 67,
    icon: 'ri-search-eye-line',
    color: 'accent',
  },
  {
    id: 6,
    title: '动漫追番日历',
    count: 156,
    icon: 'ri-ghost-smile-line',
    color: 'secondary',
  },
  {
    id: 7,
    title: '纪录片天地',
    count: 45,
    icon: 'ri-camera-lens-line',
    color: 'primary',
  },
  {
    id: 8,
    title: '综艺娱乐',
    count: 112,
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
  },
  {
    id: 9,
    title: '4K超清专区',
    count: 74,
    icon: 'ri-4k-line',
    color: 'secondary',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '即点即播',
    description: 'CDN全球加速节点覆盖，点击播放按钮后毫秒级响应，告别漫长加载等待。',
  },
  {
    id: 2,
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '支持1080P至4K多档清晰度自由切换，根据网络状况智能适配最佳画质。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '手机、平板、电脑无缝切换，观影进度自动同步，随时随地接着看。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净观影',
    description: '无弹窗广告、无强制跳转，沉浸式观影体验，专注内容本身。',
  },
  {
    id: 5,
    icon: 'ri-refresh-line',
    title: '极速更新',
    description: '院线下映后48小时内上线高清资源，热门剧集当日同步更新。',
  },
];

export const topicItems = [
  { id: 1, name: '消失的她2', heat: '98.6万', trend: 'up', rank: 1 },
  { id: 2, name: '长安十二时辰2', heat: '87.3万', trend: 'up', rank: 2 },
  { id: 3, name: '破墓', heat: '76.1万', trend: 'hot', rank: 3 },
  { id: 4, name: '周处除三害', heat: '65.8万', trend: 'up', rank: 4 },
  { id: 5, name: '犯罪都市4', heat: '58.2万', trend: 'new', rank: 5 },
  { id: 6, name: '重生', heat: '49.7万', trend: 'up', rank: 6 },
  { id: 7, name: '首尔之春', heat: '43.5万', trend: 'up', rank: 7 },
  { id: 8, name: '封神第二部', heat: '38.9万', trend: 'new', rank: 8 },
  { id: 9, name: '流浪地球3', heat: '35.1万', trend: 'hot', rank: 9 },
  { id: 10, name: '鱿鱼游戏2', heat: '31.6万', trend: 'up', rank: 10 },
];

export const mediaItems = [
  {
    id: 1,
    title: '消失的她2 - 深海迷局预告',
    duration: '02:35',
    views: '128.6万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20ocean%20scene%20with%20mysterious%20underwater%20atmosphere%2C%20deep%20blue%20and%20teal%20tones%2C%20thriller%20movie%20aesthetic%2C%20dramatic%20lighting%20through%20water%2C%20cinematic%20composition&width=640&height=360&seq=media-thumb-01&orientation=landscape',
  },
  {
    id: 2,
    title: '长安十二时辰2 - 终极对决',
    duration: '04:18',
    views: '96.3万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20dramatic%20cinematic%20lighting%2C%20historical%20drama%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20composition&width=640&height=360&seq=media-thumb-02&orientation=landscape',
  },
  {
    id: 3,
    title: '破墓 - 韩国年度恐怖巨制',
    duration: '03:47',
    views: '82.1万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20Korean%20horror%20film%20scene%20with%20grave%20and%20fog%2C%20cinematic%20atmospheric%20lighting%2C%20cold%20muted%20tones%2C%20suspenseful%20composition%2C%20professional%20film%20aesthetic&width=640&height=360&seq=media-thumb-03&orientation=landscape',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档·华语电影盛宴',
    description: '精选今夏最受期待的20部华语大片，《封神第二部》《流浪地球3》领衔上映，全程高清呈现。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20cinema%20summer%20blockbuster%20collage%20with%20dramatic%20warm%20golden%20and%20crimson%20lighting%2C%20cinematic%20film%20poster%20aesthetic%2C%20grand%20scale%20composition%2C%20professional%20movie%20marketing%20style&width=800&height=450&seq=carousel-banner-01&orientation=landscape',
    tag: '专题策划',
  },
  {
    id: 2,
    title: '韩国犯罪悬疑片精选',
    description: '从《破墓》到《犯罪都市4》，韩国电影年度高分作品一网打尽，中文字幕精校版同步更新。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20Korean%20crime%20thriller%20aesthetic%20with%20moody%20urban%20night%20lighting%2C%20film%20noir%20style%2C%20professional%20cinematography%20composition%2C%20dramatic%20shadows&width=800&height=450&seq=carousel-banner-02&orientation=landscape',
    tag: '韩影专区',
  },
  {
    id: 3,
    title: '日剧经典·治愈与悬疑',
    description: '《重启人生》《地面师》等人气日剧全集上线，精校字幕搭配高清画质，沉浸式追剧体验。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20cinematic%20scene%20with%20warm%20nostalgic%20lighting%2C%20cherry%20blossom%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20soft%20pastel%20tones%2C%20emotional%20storytelling%20composition&width=800&height=450&seq=carousel-banner-03&orientation=landscape',
    tag: '日剧合集',
  },
  {
    id: 4,
    title: '4K超清专区·极致观影',
    description: '精心修复经典影片4K版本，《教父》《肖申克的救赎》等影史佳作以全新画质重生，细节纤毫毕现。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%204K%20film%20restoration%20aesthetic%20with%20classic%20movie%20projector%20and%20film%20reel%2C%20warm%20vintage%20golden%20lighting%2C%20professional%20cinema%20atmosphere%2C%20rich%20textures&width=800&height=450&seq=carousel-banner-04&orientation=landscape',
    tag: '经典重制',
  },
  {
    id: 5,
    title: '悬疑推理剧场·烧脑特辑',
    description: '从国产悬疑到日韩推理，精选50部高分烧脑影片。反转不断，每一帧都是线索，适合深夜沉浸式观影。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20film%20noir%20scene%20with%20dramatic%20shadow%20and%20light%20contrast%2C%20cinematic%20suspense%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20professional%20thriller%20movie%20style&width=800&height=450&seq=carousel-banner-05&orientation=landscape',
    tag: '烧脑推荐',
  },
  {
    id: 6,
    title: '动漫追番·2026夏季新番',
    description: '最新夏季新番同步上线，热门连载每周更新。无论是热血、治愈还是异世界，都能在这里找到。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cinematic%20composition%20with%20colorful%20summer%20atmosphere%2C%20dynamic%20energy%2C%20Japanese%20animation%20aesthetic%2C%20warm%20sunlight%20and%20vivid%20colors&width=800&height=450&seq=carousel-banner-06&orientation=landscape',
    tag: '追番必备',
  },
];

export const aboutInfo = {
  title: '关于91影视',
  description: '91影视看片下载成立于2020年，是国内领先的在线影视视频播放平台。我们致力于为影迷提供高清流畅的影视观看体验，涵盖华语电影、韩国电影、日本电视剧、好莱坞大片、动漫番剧、纪录片等多个品类。\n\n平台采用先进的CDN加速技术和智能转码方案，确保即点即播不缓冲。我们的内容团队每日更新片库，院线热门下映后48小时内即可在线观看。\n\n截至2026年7月，平台已累计收录超过5000部影视作品，服务超过800万注册用户，日均播放量突破300万次。',
  stats: [
    { label: '累计片库', value: '5,000+' },
    { label: '注册用户', value: '800万+' },
    { label: '日均播放', value: '300万+' },
  ],
};

export const appInfo = {
  title: '随时随地 畅快观影',
  subtitle: '下载91影视APP，手机观影更便捷',
  description: '支持iOS与Android双平台，与网页端账号互通，观影进度自动同步。APP专属功能：离线缓存、投屏播放、夜间模式、个性化推荐。',
  features: ['离线缓存', '投屏播放', '夜间模式', '个性推荐'],
};

export const rankingItems = [
  { id: 1, title: '消失的她2', category: '悬疑', score: 9.2, trend: 'up', rank: 1 },
  { id: 2, title: '长安十二时辰2', category: '古装', score: 9.0, trend: 'up', rank: 2 },
  { id: 3, title: '破墓', category: '恐怖', score: 8.8, trend: 'new', rank: 3 },
  { id: 4, title: '周处除三害', category: '犯罪', score: 8.7, trend: 'up', rank: 4 },
  { id: 5, title: '犯罪都市4', category: '动作', score: 8.5, trend: 'up', rank: 5 },
  { id: 6, title: '首尔之春', category: '剧情', score: 8.4, trend: 'hot', rank: 6 },
  { id: 7, title: '封神第二部', category: '奇幻', score: 8.3, trend: 'new', rank: 7 },
];

export const cardItems = [
  {
    id: 1,
    title: '消失的她2：深海迷局',
    category: '悬疑 / 犯罪',
    score: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20mysterious%20underwater%20thriller%20film%20poster%20aesthetic%2C%20deep%20ocean%20blue%20and%20teal%20tones%2C%20dramatic%20lighting%2C%20professional%20movie%20poster%20style%2C%20clean%20background&width=600&height=400&seq=card-poster-01&orientation=landscape',
    description: '陈思诚执导悬疑续作，朱一龙、倪妮再度联手，深海之下真相扑朔迷离。',
  },
  {
    id: 2,
    title: '长安十二时辰2',
    category: '古装 / 悬疑',
    score: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20Tang%20dynasty%20drama%20poster%20aesthetic%2C%20warm%20golden%20lantern%20lighting%2C%20historical%20epic%20style%2C%20professional%20TV%20series%20poster%20composition&width=600&height=400&seq=card-poster-02&orientation=landscape',
    description: '雷佳音领衔主演，长安城风云再起，权谋与危机一触即发。全36集已完结。',
  },
  {
    id: 3,
    title: '破墓',
    category: '恐怖 / 悬疑',
    score: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20horror%20film%20poster%20with%20dark%20foggy%20graveyard%20atmosphere%2C%20cold%20muted%20tones%2C%20professional%20horror%20movie%20aesthetic%2C%20ominous%20lighting&width=600&height=400&seq=card-poster-03&orientation=landscape',
    description: '韩国年度票房冠军，风水师与殡葬师联手对抗古老诅咒，全程高能无尿点。',
  },
  {
    id: 4,
    title: '周处除三害',
    category: '犯罪 / 动作',
    score: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Taiwanese%20crime%20action%20film%20poster%20aesthetic%2C%20dark%20urban%20night%20lighting%2C%20gangster%20noir%20style%2C%20professional%20movie%20poster%20composition&width=600&height=400&seq=card-poster-04&orientation=landscape',
    description: '阮经天封帝之作，未删减导演剪辑版独家上线，黑道通缉犯的终极救赎。',
  },
  {
    id: 5,
    title: '犯罪都市4',
    category: '动作 / 犯罪',
    score: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20action%20crime%20film%20poster%20with%20intense%20urban%20street%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20dramatic%20composition&width=600&height=400&seq=card-poster-05&orientation=landscape',
    description: '马东锡回归重拳出击，首尔地下犯罪网络全面瓦解，拳拳到肉的爽快动作戏。',
  },
  {
    id: 6,
    title: '首尔之春',
    category: '剧情 / 历史',
    score: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20historical%20political%20drama%20film%20poster%20aesthetic%2C%20retro%201970s%20lighting%2C%20professional%20movie%20poster%20style%2C%20dramatic%20mood&width=600&height=400&seq=card-poster-06&orientation=landscape',
    description: '黄政民、郑雨盛联袂主演，1979年韩国政变风云，豆瓣8.8分口碑炸裂。',
  },
  {
    id: 7,
    title: '封神第二部',
    category: '奇幻 / 史诗',
    score: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20mythological%20fantasy%20epic%20film%20poster%20aesthetic%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20grand%20scale%20composition&width=600&height=400&seq=card-poster-07&orientation=landscape',
    description: '乌尔善导演神话史诗续篇，姜子牙伐纣大军集结，东方奇幻视觉盛宴。',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '91影视看片下载需要注册才能观看吗？',
    answer: '不需要。91影视看片下载绝大多数内容支持免注册即点即播，打开网页即可在线看电影电视剧。注册账号后可解锁收藏夹、观影历史同步、弹幕互动等高级功能。',
  },
  {
    id: 2,
    question: '为什么播放时偶尔会出现缓冲？',
    answer: '平台采用智能CDN加速技术，正常情况下即点即播不缓冲。如遇缓冲，建议切换清晰度档位或检查本地网络连接。我们也在持续优化服务器节点覆盖，提升播放流畅度。',
  },
  {
    id: 3,
    question: '手机端可以在线观看吗？',
    answer: '完全支持。91影视看片下载网页端已适配手机、平板等移动设备，浏览器打开即可观看。同时推荐下载官方APP，支持离线缓存和投屏播放，地铁、高铁上也能畅快追剧。',
  },
  {
    id: 4,
    question: '影视资源多久更新一次？',
    answer: '片库每日更新。院线热门电影下映后48小时内上线高清资源，热门电视剧和动漫番剧当日同步更新。建议收藏本站或关注我们的更新动态，不错过任何精彩内容。',
  },
  {
    id: 5,
    question: '播放画质如何？支持4K吗？',
    answer: '平台支持从流畅到4K多档清晰度自由切换。精选热门影片提供4K超清版本，配合HDR显示设备可呈现极致画质。系统会根据您的网络状况智能推荐最佳清晰度。',
  },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门推荐', href: '#cards' },
  { label: '联系我们', href: '#contact' },
  { label: '精彩视频', href: '#media' },
  { label: 'APP下载', href: '#app' },
  { label: '专题索引', href: '#index' },
  { label: '焦点专题', href: '#carousel' },
];